import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { ConfigList } from './pages/ConfigList';
import { ConfigForm } from './pages/ConfigForm';
import { TestPage } from './pages/TestPage';
import { Results } from './pages/Results';
import { UserProvider } from './hooks/useUser.jsx';

/**
 * Main App Component
 * 
 * IAM Playground - Test SAML and OIDC integrations
 * 
 * Multi-user isolation:
 * - Each user gets a unique anonymous ID stored in localStorage
 * - Configurations are isolated per user
 * - Users cannot see each other's configurations
 */
function App() {
  return (
    <UserProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/configs" element={<ConfigList />} />
          <Route path="/configs/new" element={<ConfigForm />} />
          <Route path="/configs/:id/edit" element={<ConfigForm />} />
          <Route path="/test/:configId" element={<TestPage />} />
          <Route path="/results/:sessionId" element={<Results />} />
        </Routes>
      </Layout>
    </UserProvider>
  );
}

export default App;
